import { IQuickFiltersBlock } from '../../types/quickFilters';

export const IMAGES: { [key: string]: string } = {
  commercial: require('./assets/commercial.jpg'),
  daily_rent: require('./assets/daily_rent.jpg'),
  flat_rent: require('./assets/flat_rent.jpg'),
  flat_sale: require('./assets/flat_sale.jpg'),
  newbuilding: require('./assets/newbuilding.jpg'),
  suburban: require('./assets/suburban.jpg'),
};

export function getImageByKey(key: IQuickFiltersBlock['key']): string {
  return IMAGES[key];
}
